import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {LocationPoint} from '@/common/interfaces/location';

export const fetchSearchHistoryAction = createAsyncThunk<
	{language: string; limit: number},
	{searchHistory: LocationPoint[]},
	void
>('locationsHistory/fetchSearchHistory', async ({language, limit}, {context, success}) => {
	const searchHistory = await context.backendAPI.search.getSearchHistory(language, limit);
	return success({searchHistory});
});
